<template>
  <div
    class="mx-3 hover:bg-[var(--content-background)] w-[25px] h-[25px] flex justify-center items-center rounded-sm cursor-pointer"
    @click="openChatNotification"
  >
    <OverlayBadge
      v-if="
        notificationStore.messages.filter(
          (message) => !message.isRead && message.senderUserRoleType !== RoleType.PANEL
        ).length > 0 || notificationStore.unavailableItems.length > 0
      "
      :value="
        notificationStore.messages.filter(
          (message) => !message.isRead && message.senderUserRoleType !== RoleType.PANEL
        ).length + notificationStore.unavailableItems.length
      "
    >
      <i class="pi pi-bell" style="font-size: 18px" />
    </OverlayBadge>
    <i v-else class="pi pi-bell" style="font-size: 18px" />
  </div>
  <Popover ref="showChatNotificationOp" append-to="body" :target="'#filter-button'">
    <ChatNotification />
  </Popover>
</template>
<script setup lang="ts">
import { onMounted, ref } from 'vue'
import ChatNotification from './ChatNotification.vue'
import { connectToNotificationChannelCase } from '@/features/chat/domain/usecases/connectToNotificationChannelUseCase'
import { useNotificationStore } from '@/features/chat/presentation/stores/notificationStore'
import { getChatNotificationHistoryCase } from '@/features/chat/domain/usecases/getChatNotificationHistoryCase'
import { RoleType } from '@/features/role/domain/enums/RoleType'
const showChatNotificationOp = ref()
const notificationStore = useNotificationStore()

onMounted(async () => {
  getChatNotificationHistoryCase({
    isRead: false,
    limit: 1000,
    page: 0
  })
  await connectToNotificationChannelCase()
})

function openChatNotification() {
  showChatNotificationOp.value.toggle(event)
}
</script>
